import { render, staticRenderFns } from "./DetailLight.vue?vue&type=template&id=0105d47d&scoped=true&lang=pug&"
import script from "./DetailLight.vue?vue&type=script&lang=js&"
export * from "./DetailLight.vue?vue&type=script&lang=js&"
import style0 from "./DetailLight.vue?vue&type=style&index=0&id=0105d47d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0105d47d",
  null
  
)

export default component.exports